import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { COMMODITY_CATALOG_QUERY } from 'src/modules/settings/inventory/commodities/hooks/useCommodities';
import { COMMODITY_CATALOG_PRODUCTS_PAGE_QUERY } from 'src/modules/settings/inventory/commodities/hooks/useCommoditiesPage';
import type { BulkEditProductCostBasis, BulkEditProductCostBasisVariables } from 'types/graphql';
import { PRICING_SHEET_ENTRIES_QUERY } from './usePricingSheetEntries';

/** The operation name predates the input root and stays as it was (TAS-3660 P9 T4a). */
const BULK_EDIT_PRODUCT_COST_BASIS = gql`
  mutation BulkEditProductCostBasis($input: BulkUpdateProductCostBasisInput!) {
    bulkUpdateProductCostBasis(input: $input)
  }
`;

export function useBulkUpdateProductCostBasis() {
  const [mutate, { loading, error }] = useMutation<BulkEditProductCostBasis, BulkEditProductCostBasisVariables>(
    BULK_EDIT_PRODUCT_COST_BASIS,
    {
      // Cost basis is a catalog-grid column, and that grid is page-bounded now: refetching the
      // metadata alone would leave the edited rows showing their pre-edit values.
      refetchQueries: [PRICING_SHEET_ENTRIES_QUERY, COMMODITY_CATALOG_QUERY, COMMODITY_CATALOG_PRODUCTS_PAGE_QUERY],
    }
  );

  const bulkUpdate = useCallback(
    ({ ids, costBasis }: { ids: number[]; costBasis: number }) => mutate({ variables: { input: { ids, costBasis } } }),
    [mutate]
  );

  return { bulkUpdate, loading, error };
}
